/*
 * @Description:我的财务
 * @Author: lyy
 * @Date: 2022-07-21 19:46:54
 * @LastEditors: your Name
 * @LastEditTime: 2022-07-28 18:54:01
 */

import { getRetireExpensesFn, retireExpensesSaveFn, getFamilIncomeFn,
  familyIncomeSaveFn, getShouldPreparedFeeListFn, createFn, getFinancialNeedsAnalysisDataFn } from "@/serves/financialPlan.js";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 查询退休费用
    GetRetireExpenses(state, params) {
      return new Promise((resolve, reject) => {
        getRetireExpensesFn(params).then(async data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        });
      });
    },

    RetireExpensesSave(state, params) {
      return new Promise((resolve, reject) => {
        retireExpensesSaveFn(params).then(async data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    GetFamilIncome(state, params) {
      return new Promise((resolve, reject) => {
        getFamilIncomeFn(params).then(async data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    FamilyIncomeSave(state, params) {
      return new Promise((resolve, reject) => {
        familyIncomeSaveFn(params).then(async data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    GetShouldPreparedFeeList(state, params) {
      return new Promise((resolve, reject) => {
        getShouldPreparedFeeListFn(params).then(async data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    Create(state, params) {
      return new Promise((resolve, reject) => {
        createFn(params).then(async data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    GetFinancialNeedsAnalysisData(state, params){
      return new Promise((resolve, reject) => {
        getFinancialNeedsAnalysisDataFn(params).then(async data => {
          resolve(data);
        }).catch(err => {
          reject(err);
        });
      });
    }
  },
  getters: {

  }
};